/* eslint-disable no-dupe-keys */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Container,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  Stack,
} from "@mui/material";
import { useEffect, useState } from "react";
import Page from "src/components/Page";
import {
  VendorOrdersList,
  ordersSchool,
  packageList,
  schoolList,
  allCourierCompany,
} from "../api";
import { useSnackbar } from "notistack";
import { useQuery } from "react-query";
import "jspdf-autotable";
import Label from "src/components/Label";
import useSettings from "src/hooks/useSettings";
import Iconify from "src/components/Iconify";
import {
  SiteItem,
  formatAsINR,
} from "src/sections/@dashboard/general/analytics/AnalyticsTrafficBySite";
import { fDateTime, fDateTimeNew } from "src/utils/formatTime";
import { DatePicker, LoadingButton } from "@mui/lab";
import axiosInstance from "src/utils/axios";

import WithoutPagination from "src/components/mrt-table/WithoutPagination";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ViewProduct from "./ViewProduct";
import AddRider from "../order/Add";
import MultipleOrderUpdate from "./MultipleOrderUpdate";
import GenerateLabel from "./GenerateLabel";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const ViewProduct = Loadable(lazy(() => import("./ViewProduct")));

export const productStatusList = [
  { label: "Created", value: 2 },
  { label: "Processing", value: 3 }, //generate label
  { label: "Dispatch", value: 4 }, //generate label
  { label: "Packed", value: 5 }, //generate label
  { label: "Delivered", value: 6 },
  { label: "Partial Delivered", value: 7 }, //generate label
  { label: "Cancelled", value: 8 },
  { label: "Refund", value: 9 },
  { label: "RTO", value: 10 }, //generate label
  { label: "Pending", value: 11 }, //generate label
  { label: "Payment Initiated", value: 12 }, //generate label
  { label: "Payment Failed", value: 13 }, //generate label
  { label: "Tuck Shop", value: 14 },
];

export const getStatusColor = (status) => {
  const error = [
    "Cancelled",
    "Refund",
    "Payment Initiated",
    "Payment Failed",
    "RTO",
  ];
  const warning = ["Partial Delivered", "Pending", "Processing"];
  const info = ["Delivered"];

  if (status === "Tuckshop") return "info";

  if (status) {
    if (error.includes(status)) {
      return "error";
    }
    if (warning.includes(status)) {
      return "primary";
    }
    if (info.includes(status)) {
      return "info";
    }
    return "success";
  }
  return "success";
};

const ids = [0, 1, 2, 6, 9];
export default function VendorDashboard() {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState("");
  const currentYear = new Date().getFullYear();

  const [selectedYears, setSelectedYears] = useState([currentYear]);
  const vendorID = JSON.parse(sessionStorage.getItem("vendorId"));
  const [selectedRider, setSelectedRider] = useState("");
  const [selectedPackage, setSelectedPackage] = useState("");
  const [selectedCourierCompany, setSelectedCourierCompany] = useState("");
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [loadingLabel, setLoadingLabel] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedShippingType, setSelectedShippingType] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openGenerteLabe, setOpenGenerateLabel] = useState(false);
  const [openMultiUpdate, setOpenMultiUpdate] = useState(false);
  const [dateError, setDateError] = useState("");

  const renderSafe = (value) =>
    value === null || value === undefined || value === "" ? "-" : value;

  const columns = [
    {
      accessorKey: "status",
      header: "Status",
      size: 160,

      Cell: ({ renderedCellValue, row }) => (
        <Label variant={"ghost"} color={getStatusColor(row?.original?.status)}>
          {renderedCellValue || "-"}
        </Label>
      ),
    },
    {
      accessorKey: "shippingType",
      header: "Shipping Type",
    },
    // {
    //   accessorKey: "schoolName",
    //   header: "School Name",
    // },
    {
      accessorKey: "packageName",
      header: "Package Name",
    },
    {
      accessorKey: "orderID",
      header: "Order ID",
    },
    {
      accessorKey: "createdDate",
      header: "Order Date",
      Cell: ({ renderedCellValue, row }) => (
        <>{fDateTime(row?.original?.createdDate)}</>
      ),
    },
    {
      accessorKey: "firstName",
      header: "Student Name",
      Cell: ({ row }) => (
        <span>
          {row.original.firstName} {row.original.lastName}
        </span>
      ),
    },
    {
      accessorKey: "address",
      header: "Address",
      size: 230,
      Cell: ({ renderedCellValue, row }) => (
        <Typography variant="body2">
          {row.original.address1} {row.original.address2} {row.original.city}{" "}
          {row.original.stateName} {row.original.pin}{" "}
        </Typography>
      ),
    },
    {
      accessorKey: "mobile",
      header: "Mobile No.",
      size: 120,
    },
    {
      accessorKey: "totalAmount",
      header: "Total",
      size: 150,
      Cell: ({ renderedCellValue, row }) => (
        <Typography variant="body2" fontWeight={500} color="green">
          {formatAsINR(renderedCellValue)}
        </Typography>
      ),
    },
    {
      accessorKey: "lotNumber",
      header: "Lot Number",
      size: 180,
      Cell: ({ renderedCellValue }) => (
        <Typography
          variant="body2"
          sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
        >
          {renderSafe(renderedCellValue)}
        </Typography>
      ),
    },
    {
      accessorKey: "delivery_company_name",
      header: "Delivery Company",
      Cell: ({ renderedCellValue }) => (
        <Typography
          variant="body2"
          sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
        >
          {renderSafe(renderedCellValue)}
        </Typography>
      ),
    },
    {
      accessorKey: "rider_name",
      header: "Rider Name",
      Cell: ({ renderedCellValue }) => (
        <Typography
          variant="body2"
          sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
        >
          {renderSafe(renderedCellValue)}
        </Typography>
      ),
    },
  ];

  const { data, isFetched } = useQuery({
    queryKey: ["schoolList", vendorID],
    queryFn: schoolList,
    // staleTime: Infinity,
    // cacheTime: Infinity,
  });
  const { data: courierCompanyList } = useQuery({
    queryKey: ["getData", selectedCourierCompany],
    queryFn: allCourierCompany,
  });

  const { data: PackageList } = useQuery({
    queryKey: ["getData", selectedSchool],
    queryFn: packageList,
    // staleTime: Infinity,
    // cacheTime: Infinity,
    enabled: !!selectedSchool,
  });

  const { data: orderList, isLoading } = useQuery({
    queryKey: [
      "courier-orderList",
      "",
      selectedCourierCompany,
      selectedSchool,
      selectedPackage,
      selectedStatus?.map((el) => el.value)?.join(","),
      fromDate ? fDateTimeNew(fromDate) : undefined,
      toDate ? fDateTimeNew(toDate) : undefined,
      selectedShippingType,
      selectedYears,
    ],
    queryFn: VendorOrdersList,
  });

  const { data: orderCount } = useQuery({
    queryKey: [
      "ordersSchool",
      selectedSchool,
      selectedYears,
      selectedPackage ?? "",
      selectedStatus?.map((el) => el.value)?.join(",") ?? "",
      fromDate ? fDateTimeNew(fromDate) : "",
      toDate ? fDateTimeNew(toDate) : "",
      selectedShippingType,
      selectedCourierCompany,
    ],
    queryFn: ordersSchool,
    enabled: !!selectedSchool,
  });

  useEffect(() => {
    if (isFetched && data?.data?.length > 0) {
      setTimeout(() => {
        setSelectedSchool(data.data[0].schoolID);
      }, 0);
    }
  }, [isFetched, data]);

  const handleExpot = async () => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append("search", "");
    params.append("schoolID", selectedSchool);
    params.append("packageID", selectedPackage ?? "");
    params.append(
      "status",
      selectedStatus?.map((el) => el.value)?.join(",") ?? ""
    );
    params.append("startdate", fromDate ? fDateTimeNew(fromDate) : "");
    params.append("enddate", toDate ? fDateTimeNew(toDate) : "");
    params.append("shippingType", selectedShippingType ?? "");
    params.append("courierCompanyID", selectedCourierCompany ?? "");

    const url = `/orders/vendor/orders/csv?${params.toString()}`;
    const config = {
      method: "GET",
      url: url,
      responseType: "blob",
    };
    try {
      const { data } = await axiosInstance(config);
      const outputFilename = `orders-${new Date()}.csv`;
      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      enqueueSnackbar("Failed To download", { variant: "error" });
    }
  };

  const handleExpotOptionalOrder = async () => {
    setDateError(""); // reset error

    if (!selectedSchool) {
      setDateError("Please select a school before exporting optional orders.");
      return;
    }

    if (!fromDate || !toDate) {
      setDateError("Please select both From and To dates.");
      return;
    }

    const diffInDays =
      Math.ceil(
        (new Date(toDate) - new Date(fromDate)) / (1000 * 60 * 60 * 24)
      ) + 1;

    if (diffInDays > 32) {
      setDateError("Please select dates.(Max 1 Month)");
      return;
    }

    setLoadingLabel(true);
    const params = new URLSearchParams();

    if (selectedPackage) {
      params.append("packageID", selectedPackage);
    } else if (PackageList?.data?.length > 0) {
      const allPackageIds = PackageList.data
        .map((pkg) => pkg.packageID)
        .filter(Boolean)
        .join(",");
      params.append("packageID", allPackageIds);
    }

    if (selectedStatus?.length > 0) {
      params.append("status", selectedStatus.map((el) => el.value).join(","));
    }

    params.append("startdate", fDateTimeNew(fromDate));
    params.append("enddate", fDateTimeNew(toDate));
    params.append("shippingType", selectedShippingType || "");
    params.append("years", selectedYears?.join(",") || "");

    const url = `/orders/vendor/optional/csv?${params.toString()}`;
    const config = {
      method: "GET",
      url: url,
      responseType: "blob",
    };

    try {
      const response = await axiosInstance(config);

      if (response.data.type === "application/json") {
        const text = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.readAsText(response.data);
        });

        const json = JSON.parse(text);
        throw new Error(json.message || "Unknown error occurred");
      }

      const outputFilename = `optional-order-${new Date().toISOString()}.csv`;
      const urlBlob = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = urlBlob;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      enqueueSnackbar("Optional order CSV downloaded successfully", {
        variant: "success",
      });
    } catch (error) {
      console.error("Optional order export error:", error);
      enqueueSnackbar(
        error.response?.data?.message || error.message || "No data found",
        { variant: "error" }
      );
    } finally {
      setLoadingLabel(false);
    }
  };

  return (
    <Page title="General: Vendor">
      {open && (
        <AddRider
          onClose={() => {
            setOpen(false);
            setSelectedRow(null);
          }}
          row={selectedRow}
        />
      )}
      {openGenerteLabe && (
        <GenerateLabel
          onClose={() => {
            setOpenGenerateLabel(false);
            setSelectedRow([]);
          }}
          data={selectedRow}
          selectedSchool={selectedSchool}
        />
      )}
      {openMultiUpdate && (
        <MultipleOrderUpdate
          data={selectedRows}
          onClose={() => {
            setOpenMultiUpdate(false);
            setSelectedRows([]);
          }}
          selectedSchool={selectedSchool}
        />
      )}
      <Container maxWidth={themeStretch ? false : "xl"} id={"report"}>
        {selectedRecord ? (
          <ViewProduct
            onClose={() => {
              setSelectedRecord(null);
            }}
            row={selectedRecord}
            selectedSchool={selectedSchool}
            // refetch={refetch}
          />
        ) : (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="School"
                  size="small"
                  select
                  SelectProps={{ native: false }}
                  fullWidth
                  // sx={{ maxWidth: "250px", width: "100%" }}
                  value={selectedSchool}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setSelectedSchool(e.target.value);
                    setSelectedPackage("");
                  }}
                >
                  {/* <MenuItem value={""}>Choose a School</MenuItem> */}
                  {data?.data?.map((el) => (
                    <MenuItem value={el.schoolID} key={el.schoolID}>
                      {el.schoolName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Package"
                  size="small"
                  select
                  // SelectProps={{ native: false }}
                  // sx={{ maxWidth: "250px", width: "100%" }}
                  disabled={!selectedSchool}
                  fullWidth
                  value={selectedPackage}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setSelectedPackage(e.target.value);
                  }}
                  SelectProps={{
                    displayEmpty: true,
                  }}
                  inputProps={{
                    placeholder: "Choose an Package",
                  }}
                >
                  <MenuItem value="">Choose a Package</MenuItem>
                  {PackageList &&
                    PackageList?.data?.map((el) => (
                      <MenuItem value={el.packageID} key={el.packageID}>
                        {el.packageName}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Courier Company"
                  size="small"
                  select
                  // SelectProps={{ native: false }}
                  fullWidth
                  value={selectedCourierCompany}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setSelectedCourierCompany(e.target.value);
                    setSelectedRider("");
                  }}
                  SelectProps={{
                    displayEmpty: true,
                  }}
                  inputProps={{
                    placeholder: "Choose an option",
                  }}
                >
                  <MenuItem value={""}>Choose an option</MenuItem>
                  {courierCompanyList?.data?.map((el) => (
                    <MenuItem value={el.company_ID} key={el.company_ID}>
                      {el.company_name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  multiple
                  options={productStatusList}
                  size="small"
                  limitTags={2}
                  value={selectedStatus}
                  onChange={(e, value) => {
                    setSelectedStatus(value);
                  }}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Order Flag"
                      placeholder="Select Status"
                      size="small"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Shipping Type"
                  select={true}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: false }}
                  value={selectedShippingType}
                  onChange={(e) => {
                    setSelectedShippingType(e.target.value);
                  }}
                  fullWidth
                  size="small"
                >
                  <MenuItem value="">Select Option</MenuItem>
                  <MenuItem value="1">Standard - Home Delivery</MenuItem>
                  <MenuItem value="2">Express - Home Delivery</MenuItem>
                  <MenuItem value="0">School Delivery</MenuItem>
                  <MenuItem value="3">Tuck Shop</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  multiple
                  options={Array.from({ length: 10 }, (_, i) => currentYear - i)} // Generate last 10 years from current year
                  size="small"
                  limitTags={2}
                  value={selectedYears}
                  onChange={(e, value) => {
                    if (value.length === 0) {
                      setSelectedYears([currentYear]); 
                    } else {
                      setSelectedYears(value);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Years"
                      placeholder="Choose Years"
                      size="small"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <DatePicker
                  label="Order From"
                  value={fromDate}
                  clearable
                  disabled={!selectedSchool}
                  onChange={(value) => {
                    setFromDate(value);
                    setToDate(null);
                  }}
                  disableFuture
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <DatePicker
                  label="Order to"
                  value={toDate}
                  clearable
                  onChange={(value) => {
                    setToDate(value);
                  }}
                  disableFuture
                  disabled={!fromDate}
                  minDate={fromDate}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Box mt={4}>
              <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Total Order"
                    order={orderCount?.[0]?.totalOrders || "0"}
                    price={orderCount?.[0]?.totalAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="New Order"
                    order={orderCount?.[0]?.Created || "0"}
                    price={orderCount?.[0]?.createdAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Packed"
                    order={orderCount?.[0]?.packed || "0"}
                    price={orderCount?.[0]?.packedAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Delivered"
                    order={orderCount?.[0]?.delivered || "0"}
                    price={orderCount?.[0]?.deliveredAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Partial Delivered"
                    order={orderCount?.[0]?.partial_delivered || "0"}
                    price={orderCount?.[0]?.partial_deliveredAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Dispatch"
                    order={orderCount?.[0]?.out_for_deliver || "0"}
                    price={orderCount?.[0]?.outForDeliverAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="In Progress"
                    order={orderCount?.[0]?.Processing || "0"}
                    price={orderCount?.[0]?.processingAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Cancelled"
                    order={orderCount?.[0]?.cancelled || "0"}
                    price={orderCount?.[0]?.cancelledAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Refund"
                    order={orderCount?.[0]?.refund || "0"}
                    price={orderCount?.[0]?.refundAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Pending"
                    order={orderCount?.[0]?.pending || "0"}
                    price={orderCount?.[0]?.pendingAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="RTO"
                    order={orderCount?.[0]?.rto || "0"}
                    price={orderCount?.[0]?.rtoAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Payment Initiated"
                    order={orderCount?.[0]?.payment_initiated || "0"}
                    price={orderCount?.[0]?.piAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Payment Failed"
                    order={orderCount?.[0]?.payment_failed || "0"}
                    price={orderCount?.[0]?.pfAmount || "0"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Tuck Shop"
                    order={orderCount ? orderCount[0]?.tuckshop : "-"}
                    price={orderCount ? orderCount[0]?.tuckshopAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6">
                    Delivery Methods Wise Count
                  </Typography>
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Express"
                    order={orderCount ? orderCount[0]?.Express : "-"}
                    price={orderCount ? orderCount[0]?.expressAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Standard"
                    order={orderCount ? orderCount[0]?.Standard : "-"}
                    price={orderCount ? orderCount[0]?.standardAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="School"
                    order={orderCount ? orderCount[0]?.School : "-"}
                    price={orderCount ? orderCount[0]?.SchoolAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Tuck Shop"
                    order={orderCount ? orderCount[0]?.Tuckshop : "-"}
                    price={orderCount ? orderCount[0]?.TuckshopAmount : "-"}
                  />
                </Grid>
              </Grid>

              <Box display="flex" flexDirection="column" alignItems="flex-end">
                {dateError && (
                  <Typography
                    variant="body2"
                    color="error"
                    sx={{
                      mb: 1,
                      fontWeight: 500,
                      textAlign: "right",
                    }}
                  >
                    {dateError}
                  </Typography>
                )}
              </Box>
              <Stack
                direction={"row"}
                justifyContent={"flex-end"}
                gap={2}
                mb={2}
              >
                <LoadingButton
                  variant="contained"
                  color="success"
                  onClick={handleExpot}
                  loading={loading}
                  disabled={!selectedSchool}
                >
                  Export Order CSV
                </LoadingButton>
                <LoadingButton
                  variant="contained"
                  color="success"
                  onClick={handleExpotOptionalOrder}
                  loading={loadingLabel}
                  disabled={!selectedSchool}
                >
                  Export Optional Order
                </LoadingButton>
              </Stack>

              <Box sx={{ minWidth: 3000 }}>
                <WithoutPagination
                  data={orderList || []}
                  columns={columns}
                  loading={isLoading}
                  enableRowSelection
                  enableSelectAll
                  selectAllMode="all"
                  renderRowActions={({ row }) => (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedRecord(row.original);
                          // navigate("/dashboard/order-detail", { state: row.original });
                        }}
                      >
                        <Iconify icon={"lets-icons:view"} />
                      </IconButton>
                    </Box>
                  )}
                  displayColumnDefOptions={{
                    "mrt-row-actions": {
                      size: "100",
                    },
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "16px",
                        padding: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        variant="contained"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        onClick={() => {
                          setOpenMultiUpdate(true);
                          setSelectedRows(table?.getSelectedRowModel()?.rows);
                        }}
                      >
                        Change Status(Order Wise)
                      </Button>
                      <Button
                        variant="contained"
                        disabled={
                          (!table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()) ||
                          table
                            .getSelectedRowModel()
                            ?.rows.some((el) =>
                              ids.includes(el?.original?.statusID)
                            )
                        }
                        onClick={() => {
                          setSelectedRow(table?.getSelectedRowModel()?.rows);
                          setOpenGenerateLabel(true);
                          // fetchLabel(table?.getSelectedRowModel()?.rows);
                        }}
                      >
                        Generate Label
                      </Button>
                    </Box>
                  )}
                />
              </Box>
            </Box>
          </>
        )}
      </Container>
    </Page>
  );
}
